import React, { useCallback, useEffect, useState } from "react";
import { Container } from "./style";
import { FormUserType } from "./form/index";
import { useApi } from "../../../hooks/api";
import { ModalHeader } from "../../ModalHeader";
import { useGlobal } from "../../../hooks/global";
import { ModalGeneric } from "../../ModalGeneric";
import { IOptionsProps } from "../../../interfaces";
import { ContentOrLoading } from "../../Loadings/ContentOrLoading";
import { PERMISSIONS, permissionsOptionsByType } from "../../../utils/permissions";
import { useWallet } from "../../../hooks/wallet";

interface IModalUserTypeProps {
  onCancel: Function;
  onSave: Function;
  defaultId?: string;
  openModal: boolean;
  backgroundVisible?: boolean;
}

const texts: any = {
  title: {
    new: "Cadastro de Tipo de Usuário",
    edit: "Informações do Tipo de Usuário",
  },
  subTitle: {
    new: "Informe os dados do tipo de usuário",
    edit: "Segue abaixo as informações do tipo de usuário",
  },
};

export const ModalUserType: React.FC<IModalUserTypeProps> = (props) => {
  const { onCancel, onSave, openModal, backgroundVisible, defaultId } = props;

  const { api } = useApi();
  const { theme, notify } = useGlobal();
  const { subscription } = useWallet();

  const [loading, setLoading] = useState(!!defaultId);
  const [defaultData, setDefaultData] = useState<any>(null);
  const [accommodations, setAccommodations] = useState<IOptionsProps[]>([]);
  const [accommodationGroupOptions, setAccommodationGroupOptions] = useState<IOptionsProps[]>([]);

  const searchAllDataOptions = useCallback(async () => {
    const groupsResult = await searchAccommodationsGroups();
    setAccommodationGroupOptions(groupsResult);

    const { data } = await api.get("/accommodations/all");
    setAccommodations(data.map((item: any) => ({ label: `${item?.stays_id} - ${item?.name}`, value: item.id })));
  }, [])

  const searchUserType = useCallback(async () => {
    await searchAllDataOptions();

    if (defaultId) {
      setLoading(true);
      try {
        const { data } = await api.get(`/user-types/${defaultId}`);
        const _data = {} as any;

        _data.id = data.id;
        _data.name = data.name;

      const isHaveDashboardPermission = subscription?.plans?.permissions.includes("DASHBOARD");
      const isHaveMagikeyPermission = subscription?.plans?.permissions.includes("ELECTRONIC_LOCKS_INTEGRATION");
      const isHaveMsgTemplatesPermission = subscription?.plans?.permissions.includes("PREDEFINED_MESSAGE_TEMPLATES");
      const isHaveMsgRulesPermission = subscription?.plans?.permissions.includes("MESSAGE_SENDING_RULES");
      const isHaveWppPermission = subscription?.plans?.permissions.includes("WHATSAPP_INTEGRATION");
      const isHaveAppCustomersPermission = subscription?.plans?.permissions.includes("APP_CUSTOMERS");

        Object.keys(PERMISSIONS).forEach((key: any) => {
          const options = permissionsOptionsByType(key);

          if(key === "SMARTLOCKS" && !isHaveMagikeyPermission) {
            return;
          }

          if(key === "MESSAGE-MODELS" && !isHaveMsgTemplatesPermission) {
            return;
          }

          if(key === "CUSTOMER" && !isHaveAppCustomersPermission) {
            return;
          }

          _data[key] = options
          .filter(({value}) => isHaveDashboardPermission ? true : value !== "DASHBOARD")
          .filter(({value}) => isHaveMsgRulesPermission ? true : value != "NOTIFICATIONS")
          .filter(({value}) => isHaveWppPermission ? true : value != "SEND_WPP")
          .filter((option) =>
            data.permissions.includes(option.value)
          )
        });

        _data.accommodations = data.accommodations.map((item: any) => ({
          label: item,
          value: item,
        }));

        _data.accommodations_groups = data.accommodations_groups.map(({ id, name }: any) => ({
          label: name,
          value: id,
        }))

        setDefaultData({ ..._data });
      } catch (err) {
        notify("Erro ao buscar o tipo de usuário", "error");
        onCancel();
      } finally {
        setLoading(false);
      }
    }
  }, [defaultId, searchAllDataOptions]);

  const searchAccommodationsGroups = useCallback(async () => {
    const { data } = await api.get("/accommodations-groups/all");

    const _data = data.map((item: { id: string; name: string }) => ({
      label: item.name,
      value: String(item.id),
    }));

    setAccommodationGroupOptions(_data);

    return _data as IOptionsProps[];
  }, []);

  useEffect(() => { searchUserType(); }, []);

  return (
    <ModalGeneric
      backgroundVisible={backgroundVisible}
      open={openModal}
      onClose={() => { }}
    >
      <Container theme={theme}>
        <ModalHeader
          title={texts.title[defaultId ? "edit" : "new"]}
          subTitle={texts.subTitle[defaultId ? "edit" : "new"]}
          onCancel={() => onCancel()}
          theme={theme}
        />
        <div style={{ marginBottom: 20 }} />
        <ContentOrLoading type="wave" loading={loading} theme={theme}>
          {!loading && (
            <FormUserType
              onSave={onSave}
              onCancel={onCancel}
              defaultData={defaultData}
              accommodations={accommodations}
              accommodationGroupOptions={accommodationGroupOptions}
            />
          )}
        </ContentOrLoading>
      </Container>
    </ModalGeneric>
  );
};
